
import axios from 'axios'
import eventBus from "./eventBus";
axios.defaults.baseURL = process.env.BASE_URL;

import qs from "qs";
import filterWhiteSpace from "./filterSpace";

// http request 请求拦截器，有token值则配置上token值
axios.interceptors.request.use(
  config => {
    if(config.url !== 'additionalSignature/getAllWaiting' && config.url !== 'additionalSignature/getAddSignData' ){
       // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    if (JSON.parse(localStorage.getItem('Authorization'))!== null) {

      config.headers.common['Authorization']  = JSON.parse(localStorage.getItem('Authorization')).Authorization;


    }else if(window.location.href.indexOf('/login')===-1 && JSON.parse(localStorage.getItem('Authorization'))=== null) {

     window.location.href = '/'

    }
     }
    if (config.method.toUpperCase() === 'POST' && config.data) {
      config.data = filterWhiteSpace(config.data)
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });
  axios.interceptors.response.use(function (response) {


    if(response.headers['isnew'] && response.headers['isnew'] === 'true'){

      localStorage.setItem("Authorization", JSON.stringify({ Authorization:response.headers['token']}));

    }



  return response;


}, function (error) {
  // Do something with response error
  return Promise.reject(error);
});




const handleHttpError = function (error) {
  let httpStatusCode = error.response.status
  let resultData = error.response.data
  switch (httpStatusCode) {
    case 500:

     console.log(500)
      break
    case 404:
      console.log(404)
      break
    default:
      break
  }
  throw error
}

export default {

  handleEorrorCode(response, that){
     switch (response.data.code) {

      case 1000://系统异常
      that.$notify({
        title:  "失败", message: response.data.message, type: 'error'
      });
      that.$router.push({ path: "/login" });
      localStorage.removeItem("Authorization");
      localStorage.removeItem('userName');
        break
      case 1001:  //未登录
      that.$notify({
        title:  "失败", message: response.data.message, type: 'error'
      });
      that.$router.push({ path: "/login" });
      localStorage.removeItem("Authorization");
      localStorage.removeItem('userName');
        break
      case 1004://无效用户信息
      that.$notify({
        title:  "失败", message: response.data.message, type: 'error'
      });
      that.$router.push({ path: "/login" });
      localStorage.removeItem("Authorization");
      localStorage.removeItem('userName');
        break
      case 1005://用户权限不匹配
      that.$notify({
        title:  "失败", message: response.data.message, type: 'error'
      });
      // that.$router.push({ path: "/login" });
      // localStorage.removeItem("Authorization");
      // localStorage.removeItem('userName');
      break
      case 1202://无效用户信息
      that.$notify({
        title:  "失败", message: response.data.message, type: 'error'
      });
      that.$router.push({ path: "/login" });
      localStorage.removeItem("Authorization");
      localStorage.removeItem('userName');
      break
      case 1102://程序异常
        if (response.data.message === '无效用户信息') {
          that.$router.push({ path: "/login" })
          localStorage.removeItem("Authorization")
          localStorage.removeItem('userName')
        }
      that.$notify({
        title:  "失败", message: response.data.message, type: 'error'
      });
        break
      default:
        break
    }
  },
  handleHttpError(error,that) {
    let httpStatusCode = '';

      let resultData = '';
     if(error.response != undefined){
        httpStatusCode = error.response.status;
        resultData = error.response.data;
     }

    switch (httpStatusCode) {
      case 500:
        that.$notify({
          title: httpStatusCode +'  HTTP 接口错误', message: error.response.statusText, type: 'error'
        });
        break
      case 404:
      that.$notify({
        title: httpStatusCode +'  HTTP 接口错误', message: error.response.statusText, type: 'error'
        });
        break
      case 400:

        that.$notify({
          title: httpStatusCode +'  HTTP 接口错误', message: error.response.statusText, type: 'error'
        });
        break;
       case 401:

        that.$notify({
          title: httpStatusCode +'  HTTP 接口错误', message: error.response.statusText, type: 'error'
        });
        that.$router.push({ path: "/login" });
        break
      default:
        break
    }
    throw error
  }
}



// WEBPACK FOOTER //
// ./src/common/http.js